import React from 'react';
import { TextractFieldBinding } from './index';

import Box from '@mui/material/Box';

export const TextractFieldBindings = ({
  mappings,
  fields,
  width,
  height,
  onClick,
  onSelect,
  selectedFieldIndex,
  // mandatory,
  disabledFields,
  boundCells,
  deltaAngle,
  isLoading,
}) => {
  return (
    <Box sx={{ position: 'absolute', zIndex: 99, inset: 0 }}>
      {mappings.map(({ bindingCell, name, id, metadata: { mandatory = false } }, index) => (
        <TextractFieldBinding
          key={id}
          bound={boundCells.includes(id)}
          isLoading={isLoading}
          isMandartory={mandatory}
          width={width}
          height={height}
          name={name}
          onClick={onClick}
          bindingCell={bindingCell}
          fields={fields}
          onSelect={onSelect}
          selectedFieldIndex={selectedFieldIndex}
          mandatoryField={mandatory}
          disabledFields={disabledFields}
          index={index}
          deltaAngle={deltaAngle}
        />
      ))}
    </Box>
  );
};
